:host {
  display: block;
  max-width: 100%;
  --severity-color: var(--chart-300-icon-buttons);
}

.incident-severity-panel {
  display: flex;
  height: 100%;

  &:before {
    content: '';
    width: 4px;
    position: absolute;
    left: -1px;
    top: -1px;
    height: calc(100% + 2px);
    background-color: var(--severity-color);
  }

  .panel-wrapper {
    display: flex;
    flex-flow: row;
    flex: 1;
  }

  gz-counter {
    font-weight: 500;
    display: inline-block;
    color: var(--severity-color);

    &::part(counter-value) {
      font-size: var(--incident-counter-font-size);
    }
  }
  .summary-total {
    font-size: var(--body-size-xxlarge);
    font-weight: 400;
    color: var(--main-titles-inputs-600);
  }

  .score-panel-inner {
    padding-right: calc(var(--spacer) * 2);

    gz-text {
      padding-top: 3px;
    }
  }

  .score-panel {
    flex: 1;
  }

  .info-panel {
    display: flex;
    flex-flow: column;
    flex: 0.8;
    padding: var(--spacer) var(--spacer) 0 var(--spacer);

    gz-labeled-content {
      --padding-value: var(--spacer);
      font-size: var(--body-size-xsmall);
      height: auto;
      line-height: 11px;
      color: var(--body-text-arrows-400);
      &::part(content){
        font-size: var(--body-size);
        --font-family: var(--font-family-secondary);
      }
    }

    gz-labeled-content[id='attack-types'] {
      line-height: 17px;
    }
  }
}

.summary-panel,
.root-cause-panel {
  gz-title {
    padding-bottom: var(--spacer);
    color: var(--chart-300-icon-buttons);
  }

  gz-link {
    --cursorType: pointer;
  }
}

.summary-panel {
  padding-top: calc(var(--spacer) * 3);

  div[paragraph-location='0'] {
    padding-bottom: calc(var(--spacer) * 2 - 4px);
  }
}
.root-cause-panel {
  padding-top: calc(var(--spacer) * 3);
}

#other-attack-types-text {
  color: var(--blue-layout-400-primary);
  cursor: pointer;
  &:hover {
    color: var(--blue-layout-301-active);
  }
}

#more-attack-types-card-wrapper {
  position: relative;
}

#more-attack-types-card {
  position: absolute;
  flex-direction: column;
  display: block;
  &:not(.shown) {
    display: none;
  }
  min-width: 240px;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 var(--chart-104-pressed);
  font-family: 'Montserrat', sans-serif;
  background-color: var(--white-layout-303-level-2-elevation);
  z-index: 1;
}

#more-attack-types-title {
  margin-bottom: 16px;
}

#more-attack-types-list {
  line-height: 20px;
}

#more-attack-types-close-button {
  position: absolute;
  right: 4px;
  top: 4px;
}
